import { useRef } from 'react';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import { Row, Col } from 'reactstrap';
import errorHandler from 'src/utils/error-handler';
import Button from 'src/componentes/button';
import Dialog from 'src/componentes/dialog';
import http from 'src/services/httpService';
import Input from 'src/componentes/input';
import { useSnackbar } from 'notistack';

function Edit({ id, nome, url, updateCallback, isNew, ...rest }) {
  const intl = useIntl();
  const ref = useRef();
  const [descricao, setDescricao] = useState(nome);
  const [errors, setErrors] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const modelDescricao = {
    value: descricao,
    requestChange: (novoValor) => {
      setDescricao(novoValor);
      setErrors(null);
    },
    errors: errors,
  };

  const handleClose = () => {
    if (ref.current) ref.current.close();
  };

  const Salvar = async () => {
    try {
      await http.post(url, {
        filtroFavoritoId: id,
        nome: descricao,
      });

      enqueueSnackbar(
        intl.formatMessage({ id: 'label.registroSalvoComSucesso' }),
        {
          variant: 'success',
          autoHideDuration: 3000,
        }
      );
      if (updateCallback) updateCallback();
      handleClose();
    } catch (err) {
      errorHandler(err);
    }
  };

  const handleSave = async () => {
    await Salvar();
  };

  const actions = () => {
    return [
      <>
        <Button
          key={1}
          onClick={handleClose}
          color="secondary"
          className="mr-2"
        >
          {intl.formatMessage({ id: 'label.cancelar' })}
        </Button>

        <Button key={2} onClick={handleSave} color="primary" className="mr-2">
          {intl.formatMessage({ id: 'label.salvar' })}
        </Button>
      </>,
    ];
  };

  const bgColor = '#FBFBFB';

  return (
    <Dialog
      id="preview"
      ref={ref}
      title={
        isNew
          ? intl.formatMessage({ id: 'novoFavorito' })
          : intl.formatMessage({ id: 'renomear' })
      }
      onRequestClose={handleClose}
      width={500}
      background={bgColor}
      actions={actions()}
      {...rest}
    >
      <div style={{ width: '90%', background: bgColor, margin: '0 auto' }}>
        <Row>
          <Col md={12}>
            <Input
              formStyle={{ marginBottom: 0 }}
              model={modelDescricao}
              required
            />
          </Col>
        </Row>
      </div>
    </Dialog>
  );
}

export default Edit;
